import { Widget } from './index';
import React from 'react';
import { List, Card } from 'antd';
import { useHistory } from 'react-router-dom';

const { Meta } = Card;


export class WidgetImageLink extends Widget {

  constructor(obj = {}) {
    super(obj);

    this.image = obj.image;
    this.title = obj.title;
    this.subtitle = obj.subtitle;
    this.url = obj.url;
  }
  

  getComponent() {
    return () => {
      const history = useHistory();

      const handleClick = () => {
        if (this.url) {
          if (this.url.startsWith('http')) {
            window.open(this.url, '_blank');
          } else {
            history.push(this.url);
          }
        }
      };

      return (
        <Card
          hoverable
          onClick={handleClick}
          cover={
            <img
              alt={this.title}
              src={this.image}
              style={{ width: '5rem', height: 'auto', display: 'block', margin: '12px auto 0 auto' }}
            />
          }
        >
          <Meta
            title={<div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', textAlign: 'center' }}>{this.title}</div>}
            description={
              this.subtitle
                ? <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', textAlign: 'center' }}>{this.subtitle}</div>
                : null
            }
          />
        </Card>
      );
    };
  }

  transformToWidget = (data) => {
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.type = data.type;
    this.size = data.size;
    this.image = data.image;
    this.url = data.url;
    return this;
  }
}
